import { formatDateTime, formatShortDate, timeAgo } from 'shared/helpers/formatters'

export function Timestamp({
  value,
  recent = false,
  className,
}: {
  value: string
  recent?: boolean
  className?: string
}) {
  const date = new Date(value)
  const label = recent
    ? Date.now() - date.getTime() < 24 * 60 * 60 * 1000
      ? timeAgo(value)
      : formatShortDate(value, { addYearIfNotCurrentYear: true })
    : formatDateTime(value)
  return (
    <time dateTime={value} title={date.toString()} className={className}>
      {label}
    </time>
  )
}
